import { render, staticRenderFns } from "./formUpload.vue?vue&type=template&id=56fa54b6&scoped=true&"
import script from "./formUpload.vue?vue&type=script&lang=js&"
export * from "./formUpload.vue?vue&type=script&lang=js&"
import style0 from "./formUpload.vue?vue&type=style&index=0&id=56fa54b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fa54b6",
  null
  
)

export default component.exports